import { all, fork } from "redux-saga/effects";
import orderStatus from './orderStatusUpdate';
import onboarding from "./bankOnboarding";
import seller from "./seller";
import categories from "./categories";
import bulkUpload from "./bulkUpload";
import taxCodes from "./taxCodes";
import orderDetails from "./orderDetails";
import sellerProducts from "./sellerProducts";
import updateProductQty from "./updateProductQty";
import sessionHistory from "./sessionHistory";
import productSaga from "./productSaga";
import allProductBasedOnFilters from "./getAllProductsBasedOnFiltersSaga";

export default function* rootSaga() {
  yield all([
    fork(seller),
    fork(onboarding),
    fork(categories),
    fork(bulkUpload),
    fork(taxCodes),
    fork(orderDetails),
    fork(sellerProducts),
    fork(orderStatus),
    fork(updateProductQty),
    fork(sessionHistory),
    fork(productSaga),
    fork(allProductBasedOnFilters)
  ]);
}
